import * as React from "react";
const SvgFiRrCircleEnvelope = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-envelope_svg__a)">
      <path
        fill="#062147"
        d="M14.993 5.994h-.004l-5.993.005a4.005 4.005 0 0 0-3.996 4v2.999c0 1.069.416 2.074 1.172 2.829A3.98 3.98 0 0 0 9 16.998h.003l5.993-.003a4.005 4.005 0 0 0 3.997-4v-3a3.98 3.98 0 0 0-1.173-2.83 3.98 3.98 0 0 0-2.827-1.171M8.998 7.999l5.993-.005h.002q.273 0 .529.071l-2.526 2.526c-.527.527-1.448.527-1.976 0L8.494 8.064q.242-.064.504-.065m7.995 4.996c0 1.102-.896 2-1.999 2l-5.993.003a2 2 0 0 1-1.414-.585 1.99 1.99 0 0 1-.586-1.415V9.999q0-.275.072-.529l2.535 2.536a3.38 3.38 0 0 0 2.402.995c.907 0 1.761-.354 2.401-.995l2.518-2.518q.065.247.065.507zM12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-envelope_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleEnvelope;
